import { useCallback } from "react";
import { useSearchParams } from "react-router";
import {
  SortDirection,
  withListPage,
  withListSearch,
  withListSort,
} from "../../UI/Table/listUrlParams.ts";
import {
  DEFAULT_ORDERS_SORT,
  OrderSortField,
  OrdersFilters,
} from "./OrdersListQuery.ts";
import {
  parseOrdersListQuery,
  withOrdersFilters,
} from "./ordersListUrlState.ts";

export function useOrdersListUrlState<Status extends string>(
  knownStatuses: readonly Status[],
) {
  const [searchParams, setSearchParams] = useSearchParams();
  const query = parseOrdersListQuery(searchParams, knownStatuses);

  const setSearch = useCallback(
    (search: string) =>
      setSearchParams((current) => withListSearch(current, search)),
    [setSearchParams],
  );

  const setSort = useCallback(
    (sortBy: OrderSortField, sortDirection: SortDirection) =>
      setSearchParams((current) =>
        withListSort(current, { sortBy, sortDirection }, DEFAULT_ORDERS_SORT),
      ),
    [setSearchParams],
  );

  const setFilters = useCallback(
    (filters: OrdersFilters<Status>) =>
      setSearchParams((current) => withOrdersFilters(current, filters)),
    [setSearchParams],
  );

  const toPage = useCallback(
    (pageIndex: number) =>
      setSearchParams((current) => withListPage(current, pageIndex)),
    [setSearchParams],
  );

  return { query, setSearch, setSort, setFilters, toPage };
}
